export enum CheckValue {
  UNCHECKED = 'UNCHECKED',
  CHECKING = 'CHECKING',
  CHECK_SUCCESSFUL = 'CHECK_SUCCESSFUL',
  CHECK_FAILED = 'CHECK_FAILED',
  CHECK_WARNING = 'CHECK_WARNING',
}
